import createCrud from '../../crud';
import moment from 'moment'

export const initialState = () => ({
  id: null,
  spent: "",
  entry_date: new Date(),
  reference: "",
  user_id: null,
  user: {}
})


export default createCrud({
    resource: 'effort',
    state: {
      single: initialState(),
      initialState: initialState()
    },
    getters: {
      getByStoryIdAndStatus: (state) => (id, type) => {
        return state.list.filter(log => {
          return log.entryable_id == id && log.entryable_type == type;
        })
      },
      getByItemId: (state) => (id, type) => {
        return state.list.filter(entry => {
          return entry.entryable_id == id && entry.entryable_type == type;
        })
      }
    }
  });